'use strict';
import React from 'react';
import ReactDom from 'react-dom';
import AllList from './allList';


class AllBody extends React.Component {
    constructor(props) {
        super(props);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.state = {
            tableWidth: 300,
            dragging: false,
            refX: 0,
            ini: 0,
            page: 0,
            contentNo: 15,
        };
    }
    componentDidMount() {
        let tableWidth = ReactDom.findDOMNode(this.refs.atd).clientWidth;
        this.setState({
            tableWidth: tableWidth
        });
        if (document.body.clientWidth > 600) {
            let elem = ReactDom.findDOMNode(this.refs.table);
            elem.addEventListener('mouseup', this.onTouchEnd);
            elem.addEventListener('mouseleave', this.onTouchEnd);
            elem.addEventListener('mousemove', this.onTouchMove);
            elem.addEventListener('mousedown', this.onTouchStart);
            window.addEventListener('wheel', this.handleMouseScroll);
        }
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        if (document.body.clientWidth > 768) {
            let elem = ReactDom.findDOMNode(this.refs.table);
            elem.removeEventListener('mouseup', this.onTouchEnd);
            elem.removeEventListener('mouseleave', this.onTouchEnd);
            elem.removeEventListener('mousemove', this.onTouchMove);
            elem.removeEventListener('mousedown', this.onTouchStart);
            window.removeEventListener('wheel', this.handleMouseScroll);
        }
        window.removeEventListener('scroll', this.handleScroll);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.staffsAtd != this.props.staffsAtd) {
            this.setState({
                page: 0
            });
        }
    }
    handleMouseScroll(e) {
        e.preventDefault();

        if (e.deltaY > 0) {
            //scroll down
            window.scrollBy(0, 50);
        } else {
            //scroll up
            window.scrollBy(0, -50);
        }

    }
    handleScroll(e) {
        let elem1 = ReactDom.findDOMNode(this.refs.atd);
        let elem2 = ReactDom.findDOMNode(this.refs.table);
        if (elem2.getBoundingClientRect().top < 50) {

            elem1.style.position = "absolute";
            
            if (document.body.clientWidth > 768) {
                elem2.style.paddingTop ="50px";
                elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
            } else {
                elem2.style.paddingTop ="0px";
                elem1.style.top = -elem2.getBoundingClientRect().top + "px";
            }
        } else {
            elem1.style.position = "relative";
            elem1.style.top = "0px";
            elem2.style.paddingTop ="0px";
        }

    }
    onTouchStart(e) {
        if (!this.state.dragging) {
            let touches = e.changedTouches;
            let refX;
            if (e.touches) {
                refX = e.touches[0].clientX;
            } else {
                refX = e.clientX;
            }
            let ini = ReactDom.findDOMNode(this.refs.table).scrollLeft;
            this.setState({
                ini: ini,
                refX: refX,
                dragging: true,
            });
        } else {
            this.setState({
                dragging: false
            });
        }
    }

    onTouchMove(e) {
        e.preventDefault();
        if (this.state.dragging && e.target) {
            let deltaX;
            if (e.touches) {
                deltaX = parseInt(this.state.refX - e.touches[0].clientX);
            } else {
                deltaX = parseInt(this.state.refX - e.clientX);
            }

            ReactDom.findDOMNode(this.refs.table).scrollLeft = (this.state.ini + deltaX);
        } else {
            this.setState({
                dragging: false
            });
        }
    }
    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));

        if (index != this.state.page) {
            this.setState({ page: index });
        }
    }
    onTouchEnd(e) {
        this.setState({
            dragging: false,
        });
    }
    renderPagination() {
        if (!this.props.staffsAtd) return;
        if (this.props.staffsAtd.length == 0) return;

        let pageNo = Math.ceil(this.props.staffsAtd.length / this.state.contentNo);

        let pagination = [];
        for (let i = 0; i < pageNo; i++) {
            pagination = pagination.concat(
                <li className={this.state.page == i ? "active" : ""} key={i} data-index={i} onClick={this.handleClick}>
                    <a href="#" >{i + 1}</a>
                </li>
            );
        }
        return (
            <nav className="ctr-pg" style={{ maxWidth: this.state.tableWidth + "px" }}>
                <ul className="pagination">
                    {pagination}
                </ul>
                <div className="pagination-title">page {(this.state.page + 1) + " of " + pageNo}</div>
            </nav>
        )
    }
    render() {
        let staffsAtd = [];
        for (let i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
            if (i < this.props.staffsAtd.length) {
                staffsAtd = staffsAtd.concat(this.props.staffsAtd[i]);
            }
        }
        return (
            <div>
                {this.renderPagination()}
                <div className="atd-bd-wp" ref="table">
                    <div className="atd-em-lt">
                        <table className="atd-a-tb tb-heading" ref="atd">
                            <thead>
                                <tr>
                                    <th>Staff Id</th>
                                    <th>Name</th>
                                    <th>Date</th>
                                    <th>Time In</th>
                                    <th>Time In Location</th>
                                    <th>Time In Remark</th>
                                    <th>Time Out</th>
                                    <th>Time Out Location</th>
                                    <th>Time Out Remark</th>
                                    <th>Remarks</th>
                                    <th>Total Hours</th>
                                    <th>OT Hours</th>
                                    <th></th>
                                </tr>
                            </thead>
                        </table>
                        <AllList staffsAtd={staffsAtd} processing={this.props.processing} page={this.state.page} contentNo={this.state.contentNo}
                            tableWidth={this.state.tableWidth} useFor={this.props.useFor} role={this.props.role} />
                    </div>
                </div>
                {this.renderPagination()}
            </div>
        );
    }
}
export default AllBody;


// WEBPACK FOOTER //
// ./app/components/attdComponents/allBody.js